import { createReducer, createNamespacer } from "../commons/js/utils/reducer";
import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from "lodash";

const initialState = {
    editClient: {
        clientId: {
            value: "",
            error: "",
            showError: "",
        },
        clientName: {
            value: "",
            error: "",
            showError: "",
        },
        street: {
            value: "",
            error: "",
            showError: "",
        },
        city: {
            value: "",
            error: "",
            showError: "",
        },
        zipcode: {
            value: "",
            error: "",
            showError: "",
        },
        clientState: {
            value: "",
            error: "",
            showError: "",
        },
        error: {
            value: "",
            error: "",
            showError: "",
        },
    },
    addClient: {
        clientId: {
            value: "",
            error: "",
            showError: "",
        },
        clientName: {
            value: "",
            error: "",
            showError: "",
        },
        street: {
            value: "",
            error: "",
            showError: "",
        },
        city: {
            value: "",
            error: "",
            showError: "",
        },
        zipcode: {
            value: "",
            error: "",
            showError: "",
        },
        clientState: {
            value: "",
            error: "",
            showError: "",
        },
        error: {
            value: "",
            error: "",
            showError: "",
        },
    },
};

const namespacers = {
    editClient: createNamespacer("EDIT_CLIENT"),
    addClient: createNamespacer("ADD_CLIENT"),
};

const editClientReducer = createReducer(initialState.editClient, {
    [namespacers.editClient("SET_CLIENT_NAME")]: (state, action) => {
        return {
            ...state,
            clientName: {
                ...state.clientName,
                value: action.payload.value,
            },
        };
    },
    [namespacers.editClient("SET_CLIENT_ID")]: (state, action) => {
        return {
            ...state,
            clientId: {
                ...state.clientId,
                value: action.payload.value,
            },
        };
    },
    [namespacers.editClient("SET_STREET")]: (state, action) => {
        return {
            ...state,
            street: {
                ...state.street,
                value: action.payload.value,
            },
        };
    },
    [namespacers.editClient("SET_CITY")]: (state, action) => {
        return {
            ...state,
            city: {
                ...state.city,
                value: action.payload.value,
            },
        };
    },
    [namespacers.editClient("SET_ZIPCODE")]: (state, action) => {
        return {
            ...state,
            zipcode: {
                ...state.zipcode,
                value: action.payload.value,
            },
        };
    },
    [namespacers.editClient("SET_STATE")]: (state, action) => {
        return {
            ...state,
            clientState: {
                ...state.clientState,
                value: action.payload.value,
            },
        };
    },

    [namespacers.editClient("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.editClient,
        };
    },

    [namespacers.editClient("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(
            Object.entries(errors).map((error) => {
                const [key, value] = error;
                return [
                    key,
                    {
                        ...state[key],
                        error: value,
                    },
                ];
            })
        );

        return {
            ...state,
            ...loadedFields,
        };
    },
});

const addClientReducer = createReducer(initialState.addClient, {
    [namespacers.addClient("SET_CLIENT_NAME")]: (state, action) => {
        return {
            ...state,
            clientName: {
                ...state.clientName,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_CLIENT_ID")]: (state, action) => {
        return {
            ...state,
            clientId: {
                ...state.clientId,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_STREET")]: (state, action) => {
        return {
            ...state,
            street: {
                ...state.street,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_CITY")]: (state, action) => {
        return {
            ...state,
            city: {
                ...state.city,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_STATE")]: (state, action) => {
        return {
            ...state,
            clientState: {
                ...state.clientState,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_ZIPCODE")]: (state, action) => {
        return {
            ...state,
            zipcode: {
                ...state.zipcode,
                value: action.payload.value,
            },
        };
    },
    [namespacers.addClient("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(
            Object.entries(errors).map((error) => {
                const [key, value] = error;
                return [
                    key,
                    {
                        ...state[key],
                        error: value,
                    },
                ];
            })
        );

        return {
            ...state,
            ...loadedFields,
        };
    },
    [namespacers.addClient("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.addClient,
        };
    },
});

const reducer = combineReducers({
    editClient: editClientReducer,
    addClient: addClientReducer,
});

export default reducer;
